import { Text } from "@artprov/design-system";
import PropTypes from "prop-types";

/**
 * Renderiza una barra de progreso con porcentaje de éxito.
 * El color de relleno se aplica vía inline style para garantizar visibilidad
 * independientemente de la configuración de Tailwind de la app consumidora.
 *
 * @param {Object} props
 * @param {number} props.porcentaje - Porcentaje de éxito (0-100)
 */
export default function ProgressBar({ porcentaje }) {
    return (
        <div className="space-y-2">
            <div className="flex justify-between items-center">
                <Text variant="body2" className="text-tertiary-10">
                    Porcentaje de éxito
                </Text>
                <Text variant="body2" className="font-medium text-tertiary-30">
                    {porcentaje}%
                </Text>
            </div>
            <div className="w-full bg-tertiary-90 rounded-full h-2">
                <div
                    className="h-2 rounded-full transition-all duration-500"
                    style={{ width: `${porcentaje}%`, backgroundColor: "#20701F" }}
                />
            </div>
        </div>
    );
}

ProgressBar.propTypes = {
    porcentaje: PropTypes.number.isRequired,
};
